var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEliminate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .134h35.678V36H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(6 6.866)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F89521",
    d: "M13.144 1.833h9.326l.064 2.134-5.881.041-3.444-.001-.065-2.174zm16.424 32.333a.136.136 0 0 1-.135.135H6.245a.135.135 0 0 1-.135-.135V5.854c0-.074.06-.134.135-.134h23.188c.074 0 .135.06.135.134v28.312zm5.26-30.154a.849.849 0 1 1 0 1.699l-3.575-.001c.003.048.014.094.014.144v28.312A1.835 1.835 0 0 1 29.433 36H6.245a1.835 1.835 0 0 1-1.834-1.834V5.854c0-.051.01-.099.015-.149L.85 5.704a.85.85 0 1 1 0-1.699l10.66.002V1.768c0-.902.733-1.634 1.634-1.634h9.39c.9 0 1.633.732 1.633 1.634V4.01l10.662.002zM11.292 9.301a.85.85 0 0 0-.85.85v20.29a.85.85 0 0 0 1.7 0v-20.29a.85.85 0 0 0-.85-.85zm6.548 0a.85.85 0 0 0-.85.85v20.29a.85.85 0 0 0 1.7 0v-20.29a.85.85 0 0 0-.85-.85zm6.547 0a.85.85 0 0 0-.85.85v20.29a.85.85 0 0 0 1.7 0v-20.29a.85.85 0 0 0-.85-.85z",
    mask: "url(#b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminate);
export default __webpack_public_path__ + "static/media/eliminate.f6dc2aed68647799d6699ae600a6fc66.svg";
export { ForwardRef as ReactComponent };